import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'hausmeister',
  title: 'Hausmeister-Tätigkeiten',
  description:
    'Auffälligkeiten melden, Aufgaben bearbeiten und gemeinsam Rückfragen klären.',
  icon: 'Wrench',
  order: 120,
  apiBasePath: '/api/hausmeister',

  // Kein scopes-Feld: die Anmeldung an der API macht die Plattform. Sie kennt
  // den Bereich der Umgebung, in der sie gerade läuft — useApiClient() hängt
  // das passende Token von selbst an.

  roles: ['hausmeister.admin', 'hausmeister.nutzer', 'platform.admin'],

  routes: () => import('./src/routes'),

  // Optional: eine Kennzahl für die Kachel auf der Startseite.
  // homeWidget: () => import('./src/home-widget'),
})
